import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { SessionManagerService } from '../services/session-manager.service';

@Injectable({
  providedIn: 'root'
})
export class DisabledUserGuard implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly sessionManager = inject(SessionManagerService);
  private readonly router = inject(Router);

  canActivate(): Observable<boolean> {
    return this.authService.currentUser$.pipe(
      take(1),
      map((user) => {
        if (!user) {
          return true;
        }

        if (user.status === 'disabled') {
          this.sessionManager.forceLogout('account_disabled').catch(() => {});
          return false;
        }

        return true;
      })
    );
  }
}
